import { Injectable, computed, inject } from "@angular/core";

import { AuthStoreService } from "./auth-store.service";
import { QuangAuthService } from "quang/auth";
import { takeUntilDestroyed, toObservable } from "@angular/core/rxjs-interop";
import { distinctUntilChanged } from "rxjs";
import {
  ROLE_ADMINISTRATOR,
  ROLE_MANAGER,
} from "../core/constants/roles.contants";

@Injectable({
  providedIn: "root",
})
export class AuthControllerService {
  private readonly authStore = inject(AuthStoreService);
  private readonly authService = inject(QuangAuthService);

  readonly user = this.authStore.authState.user;
  readonly roles = this.authStore.authState.roles;
  readonly isLogged = this.authStore.authState.isLogged;

  readonly isCompiler = computed<boolean>(() => {
    if (this.hasRole(ROLE_ADMINISTRATOR) || this.hasRole(ROLE_MANAGER))
      return false;
    return true;
  });

  private readonly onChangeUser$ = toObservable(this.authService.user)
    .pipe(distinctUntilChanged(), takeUntilDestroyed())
    .subscribe((user) => {
      if (user) {
        this.setAuthData(user.info, user.info?.realm_access?.roles ?? []);
      }
    });

  hasRole(role: string): boolean {
    return this.authStore.authState.roles().includes(role);
  }

  setAuthData(user: Record<string, any>, roles: string[]): void {
    this.authStore.setUser(user);
    this.authStore.setRoles(roles);
    this.authStore.setLogged(true);
  }

  clearAuth(): void {
    this.authStore.clearAuth();
  }
}
